// extracted by mini-css-extract-plugin
module.exports = {"part3":"part4_part3__28lYX","inner":"part4_inner__2j2gl","left":"part4_left__2JpiO","right":"part4_right__1BYOn"};